import { Outlet } from "@tanstack/react-router";

import { MONOLITH_SHELL_GRADIENT_CSS } from "@/components/dashboard/monolithBoardStyle";

import { DesignSystemSidebar } from "./DesignSystemSidebar";

export function DesignSystemInnerLayout() {
  return (
    <div className="flex min-h-screen flex-col lg:flex-row">
      <DesignSystemSidebar />
      <div className="min-h-0 min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}

export default function DesignSystemLayout() {
  return (
    <div
      className="min-h-screen text-neutral-950 [font-family:var(--color-lab-body),Georgia,serif]"
      style={{ backgroundImage: MONOLITH_SHELL_GRADIENT_CSS }}
    >
      <DesignSystemInnerLayout />
    </div>
  );
}
